import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { useAccountSelector } from 'src/hooks';
import { ScreenBreakpoint } from 'src/styles';
import { isAccountSuitabilityInformationComplete } from 'src/utils';

import { MyAccountLayout } from '../../../lib/Layout/MyAccountLayout/MyAccountLayout';
import { MyAccountSidebarMainMenuItemKey } from '../../../lib/Layout/MyAccountLayout/MyAccountSidebar';

import { SuitabilityInformationSection } from './SuitabilityInformationSection';

export const SuitabilityInformation = () => {
  const navigate = useNavigate();

  const isUpdateSuccess = useSelector((state: any) => Boolean(state.accounts.updateSuitabilityInformation.__succeeded));
  const { account } = useAccountSelector();

  const isMobile = useMediaQuery({ query: `(max-width: ${ScreenBreakpoint.mobile.max})` });

  const shouldSendAnalyticsEvent = () =>
    !account?.accountId && isUpdateSuccess && isAccountSuitabilityInformationComplete(account);

  const shouldRedirectToFinancialInformation = () =>
    !account?.accountId && isUpdateSuccess && isAccountSuitabilityInformationComplete(account);

  useEffect(() => {
    if (shouldSendAnalyticsEvent()) {
      window.gtag('event', 'account_suitability_information_complete');
    }
  }, [isUpdateSuccess]);

  useEffect(() => {
    if (shouldRedirectToFinancialInformation()) {
      navigate(`/accounts/financial-information`);
    }
  }, [isUpdateSuccess]);

  return (
    <MyAccountLayout
      sidebarMenuItemKey={MyAccountSidebarMainMenuItemKey.SuitabilityInformation}
      title={isMobile ? undefined : 'Suitability Information'}>
      <SuitabilityInformationSection />
    </MyAccountLayout>
  );
};
